import EditPost from "./EditPost";

export default EditPost;
